export const JWT_TOKEN = 'jwt.token'
export const JWT_REFRESH_TOKEN = 'jwt.refreshToken'

export const DELAYED_WAIT = 1000

